import React from 'react'
import HomeSlider from '../components/HomeSlider'
import AboutBlock from "../components/AboutBlock"
import ServicesBlock from '../components/ServicesBlock'
import SubscribeBlock from '../components/SubscribeBlock'
import ReviewsBlock from '../components/ReviewsBlock'
import BlogBlock from '../components/BlogBlock'

const Home = () => {
  return (
    <>
      <section className='home'>
        <div className="container home-container">
          <HomeSlider/>
        </div>
        <AboutBlock/>
        <ServicesBlock/>
        <SubscribeBlock/>
        <ReviewsBlock/>
        <BlogBlock/>
      </section>
    </>
  )
}

export default Home